// Recent purposes offered under the Purpose field, as the app's PurposeSuggestions.

/**
 * The most recently used distinct purposes that match what's typed so far (all of them when
 * nothing is typed), leaving out an exact match since there's nothing left to fill.
 */
export function purposeSuggestions(history: readonly { purpose: string | null; date: Date }[], typed: string, limit = 3): string[] {
  const query = typed.trim().toLocaleLowerCase();
  const seen = new Set<string>();
  const result: string[] = [];
  for (const entry of [...history].sort((a, b) => b.date.getTime() - a.date.getTime())) {
    const purpose = entry.purpose?.trim();
    if (!purpose) continue;
    const key = purpose.toLocaleLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    if (query && (!key.includes(query) || key === query)) continue;
    result.push(purpose);
    if (result.length === limit) break;
  }
  return result;
}
